import React from 'react';
import PropTypes, { any } from 'prop-types';

import { ToggleSwitch } from '../../../Form';

const RemoveWithdrawnPlayersFromStandingsToggle = (props) => {
    const {
        field,
        formApi,
    } = props;

    const { usapVerificationTypeId } = formApi.values;

    return (
        <div className={`col-12`}>
            <ToggleSwitch
                id={'removeWithdrawnPlayersFromStandings'}
                field={field}
                formGroupCssClass={`mb16`}
                label="Remove retired / forfeited / withdrawn players / teams from Round Robin standings"
                description="If enabled, players / team will forfeit all match results within the draw standings and be moved to the bottom of the standings to show this."
                isEventEditForm

                onChange={(val) => {
                    if (!val) {
                        formApi.setValue('removeWithdrawnPlayersFromStandings', false);
                        formApi.setError(false);
                    }
                    if (val) {
                        formApi.setValue('removeWithdrawnPlayersFromStandings', true);
                        formApi.setError(false);
                    }
                }}
                reverse={false}
                disabled={!!usapVerificationTypeId}
            />
            <div className="div div16" />

        </div>
    );
};
RemoveWithdrawnPlayersFromStandingsToggle.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
};
export default RemoveWithdrawnPlayersFromStandingsToggle;
